import { ClassThemeProvider } from '@class-ui/theme';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ClassroomRosterContent } from '../components/classroom/ClassroomRosterContent';
import { type LtiRoutesParams } from '../components/classroom/ClassroomRoutes';
import Loadable from '../components/common/loadable';
import { ClassProvider } from '../context/ClassContext';
import DownloadChatContainer from '../views/AdminSettings/DownloadChatContainer';

export const ClassroomRoster = () => {
    const { ready } = useTranslation('lti');

    const { classUuid } = useParams<LtiRoutesParams>();

    return (
        <Loadable isLoading={!ready}>
            <ClassThemeProvider>
                <ClassProvider classUuid={classUuid}>
                    <DownloadChatContainer.Provider>
                        <ClassroomRosterContent />
                    </DownloadChatContainer.Provider>
                </ClassProvider>
            </ClassThemeProvider>
        </Loadable>
    );
};
